import apiUrl from '../../../constants';
import axios from 'axios';
import iptrackerdetails from '../../../iptrackerdetails'

import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
    Validator
} from 'vee-validate'

export default {
    name: 'verifymobileno',
    components: {
      VueElementLoading
    },
    props: [],
    data() {
        return {
            token: '',
            iptrackData:'',
            userid: '',
            errormsg: '',
            successmsg: '',
            isLoading: false,
            mobileno:'',
            loginredirect: document.referrer,
            appkey:'',
            viewopt:false,
            otp:'',
            otperror:"",
            timerdata:'',
            timeshowflag:false,
            otpexpiredtime:0,
            resendotpflag:false,
            successmsg:"",
            otpvalue:null,
            linkexpiredtime:0,
            expiredtime:0,
            currentotpcount:1,
            totalotpcount:'',
            isEditing: true
        }
    },
    computed: {
    },
    mounted() {

  if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
 
        this.loginredirect = window.localStorage.getItem("loginpage");
        this.$alertify.error("Page has been refreshed, Redirecting to login page!");
        window.localStorage.clear();
        console.log(window.localStorage.getItem('loginpage'));
           window.setTimeout(()=>{
          window.location.href = this.loginredirect;
        },3000)
  console.info( "This page is not reloaded");

} else {
        this.token = this.$route.params.token;

    console.log("local storage Not found",performance);
        this.token = this.$route.params.token;
        this.checkTokenData();
  console.info( "This page is not reloaded");
}

    
    },
    methods: {    
        checkTokenData(){
          this.isEditing=true;
          this.isLoading = true;
          this.input = {
            token: this.token
          };
          window.localStorage.clear();
          axios({
            method: "POST",
            url: apiUrl.api_url + "validateverifymobiledtoken",
            data: this.input,
            headers: {
              'Authorization': 'Bearer XYZ'
            }
            }).then((response) => {
              this.isLoading = false;
              if(response.data.code==200){
                //this.successmsg = "Please enter your primary mobile number. All future communications and verification messages will be sent to this number.";
                this.userid = response.data.userid;
                this.appkey=response.data.appkey;
               this.linkexpiredtime = response.data.linkexpiredtime;
               
               window.localStorage.setItem("loginpage",response.data.redirecturl);
               this.loginredirect = window.localStorage.getItem("loginpage");
               this.loginredirect = response.data.redirecturl
               this.linkexpiredtimerfun(this.linkexpiredtime);
              }else{
                this.errormsg = response.data.error;
                this.$alertify.error(response.data.error);
                window.localStorage.clear();
                window.setTimeout(()=>{
                  window.location.href = this.loginredirect;
                },3000)
              }
            }).catch((httpException) => {
              //this.$alertify.success("Logging Failed");
              console.error('exception is:::::::::', httpException)
            })
        },
        linkexpiredtimerfun(linkexpiredtime) {

          let timerOn = true;
           var m = Math.floor(linkexpiredtime / 60);
           var s = linkexpiredtime % 60;
 
           m = m < 10 ? '0' + m : m;
           s = s < 10 ? '0' + s : s;
           // this.timerdata = m + ':' + s;
           linkexpiredtime -= 1;
 
           if(linkexpiredtime >= 0 && timerOn) {
           setTimeout(()=>{
               this.linkexpiredtimerfun(linkexpiredtime);
             },1000)
             return;
           }
           if (linkexpiredtime == -1) {
             this.resendotpflag = false;
             this.timeshowflag = false;
             this.successmsg = "";
             let message = "Your verification link has expired.";
             this.errormsg = message;
             this.$alertify.error(message);
             this.$validator.reset();
             this.errors.clear();
             window.localStorage.clear();
             window.setTimeout(()=>{
             window.location.href = this.loginredirect;
             },4000);
             console.log("url expired Time then this log execute");
           }
       },
        Virifymobileno(event) {
            this.isLoading = true;
              this.iptrackData = {
                userid: this.userid,
                email: this.userid
              },
            this.input = ({
                token: this.token,
                mobileno: this.mobileno
            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'verifymobilenosendotp',
                'data': this.input
            })
            .then((response) => {
                this.isLoading = false;
                iptrackerdetails.checkUserIP(this.iptrackData,'Verify Mobile No.',this.$route.path,this.input,response.data);
                if (response.data.code == 200) {  
                    this.errormsg="";
                    this.viewopt=true;  
                    this.timeshowflag=true;       
                    this.successmsg = response.data.msg
                    this.otpexpiredtime = response.data.otpexpiredtime;      
                    this.$alertify.success(response.data.msg);
                    this.timer(this.otpexpiredtime);
                    
                    // window.setTimeout(()=>{
                    //   window.location.href = response.data.redirecturl;
                    // },3000)                    
                } else {
                  this.viewopt=false; 
                  this.successmsg="";
                    this.errormsg = response.data.error;
                }
            })
            .catch((httpException) => {
                console.error('exception is:::::::::', httpException)
            })
        },
        resetForm(){
          this.mobileno = '',
          this.$validator.reset();
          this.errors.clear();
          //this.$router.push('/login');
        },
        onSubmit: function(event) {
          this.$validator.validateAll().then((result) => {
            if(result){
              //console.log('form is valid', this.model);
              this.Virifymobileno(event);
              return false;  
            }
          }).catch(() => {
            console.log('errors exist', this.errors)
          });
        },
        timer(remaining) {
          let timerOn = true;

          var m = Math.floor(remaining / 60);
          var s = remaining % 60;

          m = m < 10 ? '0' + m : m;
          s = s < 10 ? '0' + s : s;
          this.timerdata = m + ':' + s;
          remaining -= 1;

          if(remaining >= 0 && timerOn) {
          setTimeout(()=>{
              this.timer(remaining);
            },1000)
            return;
          }

            if (this.totalotpcount && this.currentotpcount > this.totalotpcount) {
                this.resendotpflag = false;
                this.timeshowflag = false;
                this.successmsg = "";
                let message = "You’ve reached the maximum logon attempts. Please try again.";
                this.errormsg = message;
                //this.$validator.reset();
                //this.errors.clear();
                window.localStorage.clear();
                this.$alertify.error(message);
                window.setTimeout(()=>{
                window.location.href = this.loginredirect;;
              },3000);
           }else{
             //this.$validator.reset();
             this.otpvalue = null;
             this.errormsg = "";
             this.successmsg = "";
             this.$refs.otpform.reset();
             //this.errors.clear();
             this.timeshowflag = false;
             this.resendotpflag = true;
           }
       },
       resendotpfunction(e){
        this.$validator.reset();
        this.otpvalue = null;
        this.successmsg = "";
        this.errormsg = "";
        this.$refs.otpform.reset();
        this.errors.clear();
        if(!this.token){
          this.$alertify.error("Require token")
          return false;
        }
        this.input = ({
            "token": this.token,
            "mobileno":this.mobileno
        })

          this.resendotpflag = false;
          this.timeshowflag = true;
          this.isLoading = true;
         axios({
            method: 'POST',
            'url': apiUrl.api_url + "users/resenduserotpmobileverify",
            'data': this.input
        }).then((response) => {
            this.isLoading = false;
            if (response.data.code == 200) {
              console.log("resenduserotp send successfully");
              this.successmsg = response.data.msg
              this.otpexpiredtime = response.data.otpexpiredtime;
              this.currentotpcount = response.data.currentotpcount;
              this.totalotpcount = response.data.totalotpcount;
              this.timer(this.otpexpiredtime);

            }
              else if(response.data.code == 104){
                this.$alertify.error(response.data.msg);
                this.resendotpflag = false;
                this.timeshowflag = false;
                console.log("Link Has been expired please login again");
                window.localStorage.clear();
                 window.setTimeout(()=>{
                 window.location.href = this.loginredirect;
               },2000);
              } else {
                let message = response.data.msg + '. Redirecting back.'
                this.$alertify.error(message);
                window.localStorage.clear();
                console.log("resenduserotp Redirecting Back");
                window.setTimeout(()=>{
                window.location.href = this.loginredirect;
                },4000);
                this.errormsg = response.data.msg;
            }
        })
        .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
        })
    },
    submitotpfunction(event) {
      this.isLoading = true;
      this.successmsg = "";
      this.errormsg = "";
      if(!this.otpvalue){
        this.$alertify.error("Require OTP")
        return false;
      }
      this.input = ({
          "otp": this.otpvalue,
          "token": this.token,
          "mobileno":this.mobileno
      })
      console.log("payload",this.input);
      axios({
          method: 'POST',
          'url': apiUrl.api_url + "users/mobilenoverifyotp",
          'data': this.input
      }).then((response) => {
          this.isLoading = false;
          if (response.data.code == 200) {
              this.successmsg = response.data.msg
              this.$alertify.success(response.data.msg);
              event.target.reset();
              window.localStorage.clear();
              console.log("OTP Verified success");
              window.setTimeout(()=>{
              window.location.href = response.data.redirecturl;
            },3000);
          }
             else if(response.data.code == 109){
                 this.errormsg = response.data.msg
                 this.$alertify.error(response.data.msg);
                 console.log(this.errormsg);
             }
          else {
              let message = response.data.msg + '. Redirecting back.'
              this.$alertify.error(message);
              window.localStorage.clear();
              window.setTimeout(()=>{
              window.location.href = this.loginredirect;
              },4000);
              console.log("verifyuserotp  Redirecting back");

              this.errormsg = response.data.error;
          }

      })
      .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
      })

    },

    }
}

Validator.extend('verifymobile', {
    getMessage: field => "Enter 10 digit valid mobile number.",
    validate: value => {
        var strongRegex = new RegExp("^([0-9])(?=.{9,9}$)");
        return strongRegex.test(value);
    }
});



// WEBPACK FOOTER //
// ./src/views/components/verifymobileno/verifymobileno.component.js